// extracted by mini-css-extract-plugin
module.exports = {"Component":"InputNumberValidation_Component__o-mgW"};